module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_8-8e27b1bad21581e5be7dc546dac035fe.png";